import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { types } from '@bedc/types';

/**
 * Convenience wrapper to use both clsx and tailwind-merge together.
 *
 * * We cannot use twJoin because it doesn't support object syntax.
 * * Object syntax is needed to support customisation in our headless UI components.
 *
 * @param inputs clsx inputs.
 * @returns Classnames string.
 */
export const c = (...inputs: ClassValue[]) => {
	return twMerge(clsx(inputs));
};

/** Maps each text size token to its Tailwind class. */
const TEXT_SIZE_CLASSES: Record<types.ui.Size, string> = {
	'2xs': 'text-2xs',
	xs: 'text-xs',
	sm: 'text-sm',
	md: 'text-base',
	lg: 'text-lg',
	xl: 'text-xl',
	'2xl': 'text-2xl',
	'3xl': 'text-3xl',
	'4xl': 'text-4xl',
	'5xl': 'text-5xl',
	'6xl': 'text-6xl',
	'7xl': 'text-7xl',
	'8xl': 'text-8xl',
	'9xl': 'text-9xl',
};

export const tw = {
	text: {
		/**
		 * Construct classnames for text based on its size.
		 *
		 * @param size The size.
		 * @param leading Whether to factor in default line heights.
		 * @returns The text classnames.
		 */
		size: (size?: types.ui.Size, leading?: boolean) => {
			return c('text-base', size && TEXT_SIZE_CLASSES[size], !leading && 'leading-none');
		},
	},
};
